<div class="summary-content">
  <h3 class="summary-title">{{ 'add.charity.summary.title' | translateLang }}</h3>

  <div class="summary-row">
    <span class="summary-label">{{ 'add.charity.summary.charity_name' | translateLang }}</span>
    <span class="summary-value">{{ displayData?.charityName }}</span>
  </div>

  @if (displayData?.charityRegistrationNumber) {
    <div class="summary-row">
      <span class="summary-label">{{ 'add.charity.summary.registration_number' | translateLang }}</span>
      <span class="summary-value">{{ displayData.charityRegistrationNumber }}</span>
    </div>
  }

  <div class="summary-row">
    <span class="summary-label">{{ 'add.charity.summary.amount' | translateLang }}</span>
    <span class="summary-value">{{ displayData?.amount | number: '1.2-2' }} {{ displayData?.currency }}</span>
  </div>

  <div class="summary-row">
    <span class="summary-label">{{ 'add.charity.summary.country' | translateLang }}</span>
    <span class="summary-value">{{ displayData?.country }}</span>
  </div>

  @if (displayData?.charityAddress) {
    <div class="summary-row">
      <span class="summary-label">{{ 'add.charity.summary.address' | translateLang }}</span>
      <span class="summary-value">{{ displayData.charityAddress }}</span>
    </div>
  }

  <div class="summary-row">
    <span class="summary-label">{{ 'add.charity.summary.contact_name' | translateLang }}</span>
    <span class="summary-value">{{ displayData?.contactName }}</span>
  </div>

  <div class="summary-row">
    <span class="summary-label">{{ 'add.charity.summary.contact_email' | translateLang }}</span>
    <span class="summary-value">{{ displayData?.contactEmail }}</span>
  </div>

  <div class="summary-row">
    <span class="summary-label">{{ 'add.charity.summary.contact_phone' | translateLang }}</span>
    <span class="summary-value">{{ displayData?.contactPhone }}</span>
  </div>

  @if (displayData?.comments) {
    <div class="summary-row">
      <span class="summary-label">{{ 'add.charity.form.comments.label' | translateLang }}</span>
      <span class="summary-value">{{ displayData.comments }}</span>
    </div>
  }
</div>
